import { BasketFragment } from "../generated/storefront";
import { Frame } from "../types/product";

export enum FrameType {
  Standard = "standard",
  Premium = "premium",
}

export const formatBasketItemFrameDetails = (
  frameColour: Omit<Frame, Frame.Unframed>,
  frameType: FrameType,
  mounted: boolean
): string => {
  return frameColour + " / " + frameType + (mounted ? " / mounted" : "");
};

export const getBasketDiscountPct = (basket?: BasketFragment): number => {
  if (!basket || !basket.lines || !basket.lines.nodes.length) return 0;
  const basketMainItems = basket?.lines.nodes.filter((l) => !l.attributes.some((a) => a.key === "_attribute")) || [];
  const basketCount = basketMainItems.reduce((total, i) => total + i.quantity, 0);

  if (basketCount === 2) return 0.15;
  if (basketCount >= 3) return 0.2;
  return 0;
};

export const getFutureDiscountPct = (basket?: BasketFragment): number => {
  if (!basket || !basket.lines || !basket.lines.nodes.length) return 0;
  const basketMainItems = basket?.lines.nodes.filter((l) => !l.attributes.some((a) => a.key === "_attribute")) || [];
  const basketCount = basketMainItems.reduce((total, i) => total + i.quantity, 0);
  if (basketCount === 1) return 0.15;
  if (basketCount >= 2) return 0.2;
  return 0;
};
